/* N1 — pequenos acertos que valem em todas as páginas (a camada da ficha de produto vive em n1-addons.js).
   Hoje: a barra "Customers rate us" do Judge.me por baixo do menu, refeita numa só linha com a identidade N1.
   Se este ficheiro não correr, a barra original do Judge.me fica como está. */
(function () {
  'use strict';
  if (window.__n1SiteLoaded) return;
  window.__n1SiteLoaded = true;

  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.6l2.9 5.9 6.5.9-4.7 4.6 1.1 6.4-5.8-3-5.8 3 1.1-6.4L2.6 9.4l6.5-.9z"/></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="11"/><path d="M7 12.5l3.2 3.2L17 9" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function q(el, s) { return el.querySelector(s); }

  function ratingBar() {
    var w = q(document, '.jdgm-all-reviews-text');
    if (!w) return false;

    function build() {
      if (q(w, '.n1a-rate')) return;
      var t = q(w, '.jdgm-all-reviews-text__text');
      var rat = q(w, '.jdgm-all-reviews-rating');
      var score = (t && t.getAttribute('data-score')) || (rat && rat.getAttribute('data-score')) || '';
      var n = (t && t.getAttribute('data-number-of-reviews')) || '';
      if (!score || !n) return;                     // sem dados: deixa a barra original
      var a = q(w, 'a[href*="judge.me"]');
      var link = a ? a.href : 'https://app.judge.me/reviews/stores/n1glovesusa.com';
      var nota = (Math.round(parseFloat(score) * 10) / 10).toFixed(1);
      var total = parseInt(String(n).replace(/[^0-9]/g, ''), 10);
      if (!total) return;
      var cheias = Math.round(parseFloat(score));
      var estrelas = '';
      for (var i = 1; i <= 5; i++) estrelas += '<i class="n1a-rate-star' + (i <= cheias ? ' is-on' : '') + '">' + STAR + '</i>';
      w.classList.add('n1a-rate-wrap');
      w.innerHTML = '<a class="n1a-rate" href="' + link + '" target="_blank" rel="noopener">' +
        '<span class="n1a-rate-stars">' + estrelas + '</span>' +
        '<b class="n1a-rate-score">' + nota + '</b>' +
        '<span class="n1a-rate-sep"></span>' +
        '<span class="n1a-rate-txt"><b>' + total.toLocaleString('en-US') + '</b> <span class="n1a-rate-long">verified </span>reviews</span>' +
        '<span class="n1a-rate-check">' + CHECK + '</span>' +
        '</a>';
    }

    build();
    // a app pode voltar a desenhar o widget: repõe a nossa versão, sem entrar em ciclo
    new MutationObserver(function () { if (!q(w, '.n1a-rate')) build(); }).observe(w, { childList: true });
    return true;
  }

  /* faixa a rolar: destaca as percentagens a amarelo e os separadores, sem mudar o texto */
  function marquee() {
    var els = document.querySelectorAll('.marquee .marquee__text span');
    if (!els.length) return;
    Array.prototype.forEach.call(els, function (s) {
      if (s.__n1a) return;
      s.__n1a = true;
      var t = s.textContent;
      if (!/[−-]\s?\d+%/.test(t) && t.indexOf('·') < 0) return;
      var html = t
        .replace(/([−-]\s?\d+\s?%)/g, '<em class="n1a-mq-pct">$1</em>')
        .replace(/·/g, '<span class="n1a-mq-dot">·</span>');
      // a etiqueta antes do primeiro separador (ex.: "Stack-up sale") fica preta sobre amarelo,
      // para não se confundir com as percentagens a amarelo
      html = html.replace(/^\s*([^<·]{3,40}?)\s*(?=<span class="n1a-mq-dot")/, '<em class="n1a-mq-lbl">$1</em>');
      s.innerHTML = html;
    });
  }


  /* carrosséis: arrastar com o rato no desktop (a barra de scroll fica escondida por CSS).
     Delegação no documento: apanha também os carrosséis que entram depois (recomendados, etc.). */
  function dragScroll() {
    var fine = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches;
    if (!fine) return;                                   // telemóvel/tablet: o dedo já faz isto
    var cur = null, x0 = 0, left0 = 0, moved = false, guard = false;

    function scroller(t) { return t && t.closest ? t.closest('.overflow-scroller') : null; }

    document.addEventListener('mouseover', function (e) {
      var el = scroller(e.target);
      if (el) el.classList.toggle('n1c-can-drag', el.scrollWidth > el.clientWidth + 4);
    });

    document.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      var el = scroller(e.target);
      if (!el || el.scrollWidth <= el.clientWidth + 4) return;
      if (e.target.closest('button, input, select, textarea')) return;
      cur = el; x0 = e.pageX; left0 = el.scrollLeft; moved = false;
    });

    document.addEventListener('mousemove', function (e) {
      if (!cur) return;
      var dx = e.pageX - x0;
      if (!moved && Math.abs(dx) < 5) return;             // um clique normal não conta como arrasto
      if (!moved) { moved = true; cur.classList.add('n1c-dragging'); }
      e.preventDefault();
      cur.scrollLeft = left0 - dx;
    });

    document.addEventListener('mouseup', function () {
      if (!cur) return;
      var el = cur; cur = null;
      if (moved) { guard = true; el.classList.remove('n1c-dragging'); }
      moved = false;
    });

    // depois de arrastar, o clique que vem a seguir não deve abrir o produto
    document.addEventListener('click', function (e) {
      if (!guard) return;
      guard = false;
      e.preventDefault(); e.stopPropagation();
    }, true);

    document.addEventListener('dragstart', function (e) {
      if (cur) e.preventDefault();
    });
  }

  /* quantidade na ficha de produto: − 1 + em vez da caixinha do tema */
  function quantity() {
    var boxes = document.querySelectorAll('.product__quantity input[type="number"][name="quantity"]');
    Array.prototype.forEach.call(boxes, function (inp) {
      if (inp.__n1q || !inp.parentNode) return;
      inp.__n1q = true;
      var wrap = document.createElement('div');
      wrap.className = 'n1q';
      inp.parentNode.insertBefore(wrap, inp);
      var minus = document.createElement('button');
      minus.type = 'button'; minus.className = 'n1q__btn'; minus.innerHTML = '&minus;';
      minus.setAttribute('aria-label', 'Decrease quantity');
      var plus = document.createElement('button');
      plus.type = 'button'; plus.className = 'n1q__btn'; plus.innerHTML = '+';
      plus.setAttribute('aria-label', 'Increase quantity');
      wrap.appendChild(minus); wrap.appendChild(inp); wrap.appendChild(plus);

      function num(v, d) { var n = parseInt(v, 10); return isNaN(n) ? d : n; }
      function lo() { return num(inp.getAttribute('min'), 1); }
      function hi() { var n = num(inp.getAttribute('max'), 0); return n > 0 ? n : 9999; }
      function sync() { var v = num(inp.value, lo()); minus.disabled = v <= lo(); plus.disabled = v >= hi(); }
      function set(v) {
        v = Math.max(lo(), Math.min(hi(), v));
        inp.value = v;
        inp.dispatchEvent(new Event('input', { bubbles: true }));
        inp.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      }
      minus.addEventListener('click', function () { set(num(inp.value, lo()) - 1); });
      plus.addEventListener('click', function () { set(num(inp.value, lo()) + 1); });
      inp.addEventListener('change', sync);
      inp.addEventListener('input', sync);
      sync();
    });
  }

  function start() {
    try { marquee(); } catch (e) { }
    try { dragScroll(); } catch (e) { }
    try { quantity(); } catch (e) { }
    setTimeout(function () { try { quantity(); } catch (e) { } }, 1200);
    if (ratingBar()) return;
    // o widget entra depois do script do Judge.me: espera por ele
    var n = 0, t = setInterval(function () { if (ratingBar() || ++n > 80) clearInterval(t); }, 150);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
